(function () {

    var laroute = (function () {

        var routes = {

            absolute: true,
            rootUrl: 'http://www.bsg.dev',
            routes : [{"host":null,"methods":["GET","HEAD"],"uri":"backend","name":"admin_dashboard","action":"Frozennode\Administrator\AdminController@dashboard"},{"host":null,"methods":["GET","HEAD"],"uri":"backend\/file_download","name":"admin_file_download","action":"Frozennode\Administrator\AdminController@fileDownload"},{"host":null,"methods":["GET","HEAD"],"uri":"backend\/page\/{page}","name":"admin_page","action":"Frozennode\Administrator\AdminController@page"},{"host":null,"methods":["GET","HEAD"],"uri":"backend\/settings\/{settings}","name":"admin_settings","action":"Frozennode\Administrator\AdminController@settings"},{"host":null,"methods":["GET","HEAD"],"uri":"backend\/settings\/{settings}\/file","name":"admin_settings_display_file","action":"Frozennode\Administrator\AdminController@displayFile"},{"host":null,"methods":["POST"],"uri":"backend\/settings\/{settings}\/save","name":"admin_settings_save","action":"Frozennode\Administrator\AdminController@settingsSave"},{"host":null,"methods":["POST"],"uri":"backend\/settings\/{settings}\/custom_action","name":"admin_settings_custom_action","action":"Frozennode\Administrator\AdminController@settingsCustomAction"},{"host":null,"methods":["POST"],"uri":"backend\/settings\/{settings}\/{field}\/file_upload","name":"admin_settings_file_upload","action":"Frozennode\Administrator\AdminController@fileUpload"},{"host":null,"methods":["GET","HEAD"],"uri":"backend\/switch_locale\/{locale}","name":"admin_switch_locale","action":"Frozennode\Administrator\AdminController@switchLocale"},{"host":null,"methods":["GET","HEAD"],"uri":"backend\/{model}","name":"admin_index","action":"Frozennode\Administrator\AdminController@index"},{"host":null,"methods":["GET","HEAD"],"uri":"backend\/{model}\/new","name":"admin_new_item","action":"Frozennode\Administrator\AdminController@item"},{"host":null,"methods":["POST"],"uri":"backend\/{model}\/update_options","name":"admin_update_options","action":"Frozennode\Administrator\AdminController@updateOptions"},{"host":null,"methods":["GET","HEAD"],"uri":"backend\/{model}\/file","name":"admin_display_file","action":"Frozennode\Administrator\AdminController@displayFile"},{"host":null,"methods":["POST"],"uri":"backend\/{model}\/rows_per_page","name":"admin_rows_per_page","action":"Frozennode\Administrator\AdminController@rowsPerPage"},{"host":null,"methods":["POST"],"uri":"backend\/{model}\/results","name":"admin_get_results","action":"Frozennode\Administrator\AdminController@results"},{"host":null,"methods":["POST"],"uri":"backend\/{model}\/custom_action","name":"admin_custom_model_action","action":"Frozennode\Administrator\AdminController@customModelAction"},{"host":null,"methods":["GET","HEAD"],"uri":"backend\/{model}\/{id}","name":"admin_get_item","action":"Frozennode\Administrator\AdminController@item"},{"host":null,"methods":["POST"],"uri":"backend\/{model}\/{field}\/file_upload","name":"admin_file_upload","action":"Frozennode\Administrator\AdminController@fileUpload"},{"host":null,"methods":["POST"],"uri":"backend\/{model}\/{id?}\/save","name":"admin_save_item","action":"Frozennode\Administrator\AdminController@save"},{"host":null,"methods":["POST"],"uri":"backend\/{model}\/{id}\/delete","name":"admin_delete_item","action":"Frozennode\Administrator\AdminController@delete"},{"host":null,"methods":["POST"],"uri":"backend\/{model}\/{id}\/custom_action","name":"admin_custom_model_item_action","action":"Frozennode\Administrator\AdminController@customModelItemAction"},{"host":null,"methods":["GET","HEAD"],"uri":"\/","name":"home","action":"App\Http\Controllers\Shop\ShopController@landingpage"},{"host":null,"methods":["GET","HEAD"],"uri":"shops\/{typeSlug?}\/{categoryString?}","name":"shops","action":"App\Http\Controllers\Shop\ShopController@index"},{"host":null,"methods":["GET","HEAD"],"uri":"merkliste","name":"wishlist","action":"App\Http\Controllers\Shop\WishlistController@index"},{"host":null,"methods":["POST"],"uri":"merken","name":"wishlist.add","action":"App\Http\Controllers\Shop\WishlistController@add"},{"host":null,"methods":["POST"],"uri":"entfernen","name":"wishlist.remove","action":"App\Http\Controllers\Shop\WishlistController@remove"},{"host":null,"methods":["GET","HEAD"],"uri":"products","name":"products","action":"App\Http\Controllers\Product\ProductController@landingpage"},{"host":null,"methods":["GET","HEAD"],"uri":"email_bestaetigen\/{email}\/{code}","name":"confirm","action":"App\Http\Controllers\General\UserController@confirm"},{"host":null,"methods":["GET","HEAD"],"uri":"meine_daten","name":"user.edit","action":"App\Http\Controllers\General\UserController@edit"},{"host":null,"methods":["POST"],"uri":"meine_daten","name":"user.edit","action":"App\Http\Controllers\General\UserController@update"},{"host":null,"methods":["GET","HEAD"],"uri":"konto_loeschen","name":"user.cancel","action":"App\Http\Controllers\General\UserController@cancel"},{"host":null,"methods":["POST"],"uri":"konto_loeschen","name":null,"action":"App\Http\Controllers\General\UserController@destroy"},{"host":null,"methods":["GET","HEAD"],"uri":"impressum","name":"about","action":"App\Http\Controllers\General\SiteController@about"},{"host":null,"methods":["GET","HEAD"],"uri":"login","name":"login","action":"App\Http\Controllers\Auth\AuthController@getLogin"},{"host":null,"methods":["POST"],"uri":"login","name":null,"action":"App\Http\Controllers\Auth\AuthController@postLogin"},{"host":null,"methods":["GET","HEAD"],"uri":"logout","name":"logout","action":"App\Http\Controllers\Auth\AuthController@getLogout"},{"host":null,"methods":["GET","HEAD"],"uri":"registrieren","name":"register","action":"App\Http\Controllers\Auth\AuthController@getRegister"},{"host":null,"methods":["POST"],"uri":"registrieren","name":null,"action":"App\Http\Controllers\Auth\AuthController@postRegister"},{"host":null,"methods":["GET","HEAD"],"uri":"passwort","name":"password","action":"App\Http\Controllers\Auth\PasswordController@getEmail"},{"host":null,"methods":["POST"],"uri":"passwort","name":null,"action":"App\Http\Controllers\Auth\PasswordController@postEmail"},{"host":null,"methods":["GET","HEAD"],"uri":"passwort_reset\/{email}\/{token}","name":"password.reset","action":"App\Http\Controllers\Auth\PasswordController@getReset"},{"host":null,"methods":["POST"],"uri":"passwort_reset","name":"password.reset.post","action":"App\Http\Controllers\Auth\PasswordController@postReset"},{"host":null,"methods":["GET","HEAD"],"uri":"_debugbar\/open","name":"debugbar.openhandler","action":"Barryvdh\Debugbar\Controllers\OpenHandlerController@handle"},{"host":null,"methods":["GET","HEAD"],"uri":"_debugbar\/clockwork\/{id}","name":"debugbar.clockwork","action":"Barryvdh\Debugbar\Controllers\OpenHandlerController@clockwork"},{"host":null,"methods":["GET","HEAD"],"uri":"_debugbar\/assets\/stylesheets","name":"debugbar.assets.css","action":"Barryvdh\Debugbar\Controllers\AssetController@css"},{"host":null,"methods":["GET","HEAD"],"uri":"_debugbar\/assets\/javascript","name":"debugbar.assets.js","action":"Barryvdh\Debugbar\Controllers\AssetController@js"}],

            route : function (name, parameters, route) {
                route = route || this.getByName(name);

                if ( ! route ) {
                    return undefined;
                }

                return this.toRoute(route, parameters);
            },

            url: function (url, parameters) {
                parameters = parameters || [];

                var uri = url + '/' + parameters.join('/');

                return this.getCorrectUrl(uri);
            },

            toRoute : function (route, parameters) {
                var uri = this.replaceNamedParameters(route.uri, parameters);
                var qs  = this.getRouteQueryString(parameters);

                return this.getCorrectUrl(uri + qs);
            },

            replaceNamedParameters : function (uri, parameters) {
                uri = uri.replace(/\{(.*?)\??\}/g, function(match, key) {
                    if (parameters.hasOwnProperty(key)) {
                        var value = parameters[key];
                        delete parameters[key];
                        return value;
                    } else {
                        return match;
                    }
                });

                // Strip out any optional parameters that were not given
                uri = uri.replace(/\/\{.*?\?\}/g, '');

                return uri;
            },

            getRouteQueryString : function (parameters) {
                var qs = [];
                for (var key in parameters) {
                    if (parameters.hasOwnProperty(key)) {
                        qs.push(key + '=' + parameters[key]);
                    }
                }

                if (qs.length < 1) {
                    return '';
                }

                return '?' + qs.join('&');
            },

            getByName : function (name) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].name === name) {
                        return this.routes[key];
                    }
                }
            },

            getByAction : function(action) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].action === action) {
                        return this.routes[key];
                    }
                }
            },

            getCorrectUrl: function (uri) {
                var url = '/' + uri.replace(/^\/?/, '');

                if(!this.absolute)
                    return url;

                return this.rootUrl.replace('/\/?$/', '') + url;
            }
        };

        var getLinkAttributes = function(attributes) {
            if ( ! attributes) {
                return '';
            }

            var attrs = [];
            for (var key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    attrs.push(key + '="' + attributes[key] + '"');
                }
            }

            return attrs.join(' ');
        };

        var getHtmlLink = function (url, title, attributes) {
            title      = title || url;
            attributes = getLinkAttributes(attributes);

            return '<a href="' + url + '" ' + attributes + '>' + title + '</a>';
        };

        return {
            // Generate a url for a given controller action.
            // laroute.action('HomeController@getIndex', [params = {}])
            action : function (name, parameters) {
                parameters = parameters || {};

                return routes.route(name, parameters, routes.getByAction(name));
            },

            // Generate a url for a given named route.
            // laroute.route('routeName', [params = {}])
            route : function (route, parameters) {
                parameters = parameters || {};

                return routes.route(route, parameters);
            },

            // Generate a fully qualified URL to the given path.
            // laroute.route('url', [params = {}])
            url : function (route, parameters) {
                parameters = parameters || {};

                return routes.url(route, parameters);
            },

            // Generate a html link to the given url.
            // laroute.link_to('foo/bar', [title = url], [attributes = {}])
            link_to : function (url, title, attributes) {
                url = this.url(url);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given route.
            // laroute.link_to_route('route.name', [title=url], [parameters = {}], [attributes = {}])
            link_to_route : function (route, title, parameters, attributes) {
                var url = this.route(route, parameters);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given controller action.
            // laroute.link_to_action('HomeController@getIndex', [title=url], [parameters = {}], [attributes = {}])
            link_to_action : function(action, title, parameters, attributes) {
                var url = this.action(action, parameters);

                return getHtmlLink(url, title, attributes);
            }

        };

    }).call(this);

    /**
     * Expose the class either via AMD, CommonJS or the global object
     */
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return laroute;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = laroute;
    }
    else {
        window.laroute = laroute;
    }

}).call(this);

